/** Weak / common passwords (case-insensitive exact match after normalize). */
const WEAK_EXACT = new Set(
  [
    'password',
    'password1',
    'p@ssw0rd',
    'p@ssword',
    'passw0rd',
    'admin123',
    'qwerty',
    'qwerty123',
    'letmein',
    'welcome1',
    'welcome123',
    'aa123456aa@',
    'aa123456aa',
    'user1234',
    'test1234',
  ].map((s) => s.toLowerCase())
)

/**
 * True if substring of 4+ digits is strictly ascending or descending (e.g. 1234, 4321).
 */
export function hasSequentialDigitRun(password) {
  const s = String(password)
  for (let i = 0; i <= s.length - 4; i++) {
    const w = s.slice(i, i + 4)
    if (!/^\d{4}$/.test(w)) continue
    const d = [...w].map(Number)
    let asc = true
    let desc = true
    for (let j = 1; j < 4; j += 1) {
      if (d[j] !== d[j - 1] + 1) asc = false
      if (d[j] !== d[j - 1] - 1) desc = false
    }
    if (asc || desc) return true
  }
  return false
}

export function isWeakOrCommonPassword(password) {
  const lower = String(password).toLowerCase()
  if (WEAK_EXACT.has(lower)) return true
  // Leetspeak-style "password"
  const debased = lower
    .replace(/@/g, 'a')
    .replace(/0/g, 'o')
    .replace(/1/g, 'i')
    .replace(/3/g, 'e')
    .replace(/5/g, 's')
    .replace(/\$/g, 's')
  if (debased.includes('password') && debased.length < 24) return true
  return false
}

export function getPasswordPolicyState(password) {
  const p = String(password)
  const noSequential = !hasSequentialDigitRun(p)
  const notWeak = !isWeakOrCommonPassword(p)
  return {
    minLength: p.length >= 8,
    hasLower: /[a-z]/.test(p),
    hasUpper: /[A-Z]/.test(p),
    hasDigit: /\d/.test(p),
    hasSpecial: /[^A-Za-z0-9]/.test(p),
    noSequentialDigits: noSequential,
    notWeak,
  }
}

export function isPasswordPolicySatisfied(password) {
  const s = getPasswordPolicyState(password)
  return Object.values(s).every(Boolean)
}
